import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './AlumnoForm.css';
import './MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

function UploadIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 16V4M7 9l5-5 5 5" />
      <path d="M4 20h16" />
    </svg>
  );
}

export class MarcarPagoInscripcion extends Component {
  static displayName = MarcarPagoInscripcion.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errorMessage: '',
      successMessage: '',
      base64: '',
      fileName: '',
    };
    this.fileInputRef = React.createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  componentDidMount() {
    constantClass.canAccess('WWAlumnos');
  }

  clearFeedback() {
    if (this.state.errorMessage || this.state.successMessage) {
      this.setState({ errorMessage: '', successMessage: '' });
    }
  }

  handleFileChange(e) {
    this.clearFeedback();
    const file = e.target.files && e.target.files[0];

    if (!file) {
      this.setState({ base64: '', fileName: '' });
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result || '';
      const parts = String(result).split(',');
      const base64 = parts.length > 1 ? parts[1] : '';
      if (!base64) {
        this.setState({
          base64: '',
          fileName: '',
          errorMessage: 'No se pudo leer el archivo seleccionado.',
        });
        return;
      }
      this.setState({ base64, fileName: file.name, errorMessage: '' });
    };
    reader.onerror = () => {
      this.setState({
        base64: '',
        fileName: '',
        errorMessage: 'Error al leer el archivo. Seleccione otro archivo e intente nuevamente.',
      });
    };
    reader.readAsDataURL(file);
  }

  handleReset() {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = '';
    }
    this.setState({
      base64: '',
      fileName: '',
      errorMessage: '',
      successMessage: '',
    });
  }

  isFormValid() {
    return this.state.base64.length > 0;
  }

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.loading)) {
      return;
    }
    if (!this.isFormValid()) {
      this.setState({ errorMessage: 'Seleccione un archivo con los DNI a marcar.' });
      return;
    }
    this.savePago();
  }

  async savePago() {
    if (isSubmitInProgress(this.state.loading)) {
      return;
    }

    this.setState({ loading: true, errorMessage: '', successMessage: '' });

    const { data } = await constantClass.apiFetch('api/Students/pago-inscripcion', {
      method: 'POST',
      body: JSON.stringify({ Archivo: this.state.base64 }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || !data.returnModel) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo marcar el pago de inscripción. Verifique el archivo e intente nuevamente.'
        ),
      });
      return;
    }

    const result = data.returnModel;
    const actualizados = result.actualizados || 0;
    const noEncontrados = result.noEncontrados || 0;
    const lista = Array.isArray(result.dnisNoEncontrados) ? result.dnisNoEncontrados : [];
    let successMessage = `Se marcó el pago de inscripción en ${actualizados} alumno(s).`;
    if (noEncontrados > 0) {
      const detalle = lista.length ? ` DNI no encontrados: ${lista.join(', ')}.` : '';
      successMessage += ` ${noEncontrados} DNI del archivo no están en el sistema.${detalle}`;
    }

    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = '';
    }

    this.setState({
      loading: false,
      base64: '',
      fileName: '',
      successMessage,
    });
  }

  render() {
    const { loading, errorMessage, successMessage, fileName } = this.state;
    const isBusy = loading;

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-alumnos">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">Marcar Pago de Inscripción</h1>
        <p className="md-form-page__subtitle">
          Suba un archivo TXT o CSV con los DNI de los alumnos que pagaron (un DNI por línea;
          opcional encabezado &quot;DNI&quot;).
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {successMessage ? <span className="md-form-page__success">{successMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Procesando archivo, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="pago-inscripcion-archivo">
                Archivo de DNI
              </label>
              <div className="md-form-page__file-wrap">
                <input
                  ref={this.fileInputRef}
                  id="pago-inscripcion-archivo"
                  className="md-form-page__file-input"
                  type="file"
                  accept=".txt,.csv"
                  onChange={this.handleFileChange}
                  disabled={isBusy}
                />
                <p
                  className={
                    'md-form-page__file-name' + (fileName ? '' : ' md-form-page__file-name--empty')
                  }
                >
                  {fileName || 'Ningún archivo seleccionado'}
                </p>
              </div>
              <p className="md-form-page__hint">
                Ejemplo TXT/CSV:
                <br />
                DNI
                <br />
                30111222
                <br />
                30999888
              </p>
            </div>

            <div className="md-form-page__actions">
              <button
                type="submit"
                className="md-form-page__btn md-form-page__btn--primary"
                disabled={isBusy}
              >
                <UploadIcon />
                Marcar pagos
              </button>
              <button
                type="button"
                className="md-form-page__btn md-form-page__btn--secondary"
                onClick={this.handleReset}
                disabled={isBusy}
              >
                Limpiar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
